import SvgIcon from '@components/SvgIcon'
import { mobileCSS } from '@measures/responsive'
import { FunctionComponent, useContext } from 'react'
import styled, { css, useTheme } from 'styled-components'
import contextViewport, { ViewportTypeValues } from '@contexts/viewport'

const { ViewportTypeContext } = contextViewport

interface LeftArrowFaderProps {
  scrollToStart: () => void
}

interface RightArrowFaderProps {
  scrollToEnd: () => void
}

const WrapperCommonStyle = css`
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 24px);
  ${mobileCSS(css`
    grid-template-columns: 24px;
  `)}
  align-items: center;
  justify-items: center;
  position: absolute;
`

const LeftWrapper = styled.div`
  left: 0;
  z-index: 1;
  ${WrapperCommonStyle}
`

const RightWrapper = styled.div`
  bottom: 0;
  right: 0;
  ${WrapperCommonStyle}
`

interface FaderProps {
  leftOrRight: 'left' | 'right'
}

const Fader = styled.div<FaderProps>`
  ${({
    theme: {
      colors: {
        grey: { grey_20 },
      },
    },
    leftOrRight,
  }) => css`
    height: 100%;
    background: linear-gradient(
      ${leftOrRight === 'left' ? '90deg' : '270deg'},
      ${grey_20} 0%,
      #eeeeee70 90%
    );
    width: 24px;
  `}
`
const IconWrapper = styled.button`
  ${({
    theme: {
      colors: {
        grey: { grey_20 },
      },
    },
  }) =>
    css`
      height: 100%;
      background: ${grey_20};
      display: grid;
      align-items: center;
      justify-items: center;
      border: 0;
      cursor: pointer;
      padding: 0;
      line-height: 0;
    `}
`

const LeftArrowFader: FunctionComponent<LeftArrowFaderProps> = ({
  scrollToStart,
}) => {
  const theme = useTheme()
  const viewportType = useContext(ViewportTypeContext)
  const isMobile = viewportType === ViewportTypeValues.MOBILE

  return (
    <LeftWrapper>
      {!isMobile && (
        <IconWrapper aria-label="Scroll left" onClick={scrollToStart}>
          <SvgIcon
            size={24}
            iconName="header-left-arrow"
            color={theme.colors.grey.grey_80}
          />
        </IconWrapper>
      )}
      <Fader leftOrRight="left" />
    </LeftWrapper>
  )
}

const RightArrowFader: FunctionComponent<RightArrowFaderProps> = ({
  scrollToEnd,
}) => {
  const theme = useTheme()
  const viewportType = useContext(ViewportTypeContext)
  const isMobile = viewportType === ViewportTypeValues.MOBILE

  return (
    <RightWrapper>
      <Fader leftOrRight="right" />
      {!isMobile && (
        <IconWrapper aria-label="Scroll right" onClick={scrollToEnd}>
          <SvgIcon
            size={24}
            iconName="header-right-arrow"
            color={theme.colors.grey.grey_80}
          />
        </IconWrapper>
      )}
    </RightWrapper>
  )
}

const ArrowFader = { Left: LeftArrowFader, Right: RightArrowFader }

export default ArrowFader
